"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleEntityBase = void 0;
const ErrorHandlingHelper_1 = require("./ErrorHandlingHelper");
const ValidationError_1 = require("./ValidationError");
class SingleEntityBase extends ErrorHandlingHelper_1.ErrorHandlingHelper {
    constructor() {
        super(...arguments);
        this._requiredFieldsSetStatus = {};
        this._dto = {};
        this._isNew = true;
        this._isDirty = false;
        this._eventListeners = {};
        this._state = "ready";
    }
    get isNew() {
        return this._isNew;
    }
    _setIsNew(value) {
        this._isNew = value;
    }
    get isDirty() {
        return this._isDirty;
    }
    get canDelete() {
        return true;
    }
    get allRequiredFieldsSet() {
        return Object.keys(this._requiredFieldsSetStatus).find((fieldName) => (!this._requiredFieldsSetStatus[fieldName])) === undefined;
    }
    get canSave() {
        return this.allRequiredFieldsSet && this.getErrors().find((error) => (error instanceof ValidationError_1.ValidationError)) === undefined;
    }
    get state() {
        return this._state;
    }
    off(eventName, listener) {
        if (eventName === undefined) {
            this._eventListeners = {};
        }
        else if (this._eventListeners[eventName]) {
            if (listener === undefined) {
                delete this._eventListeners[eventName];
                return;
            }
            const l = this._eventListeners[eventName].length;
            for (let i = 0; i < l; i++) {
                if (this._eventListeners[eventName][i] === listener) {
                    this._eventListeners[eventName].splice(i, 1);
                    break;
                }
            }
        }
    }
    on(eventName, listener) {
        if (!this._eventListeners[eventName]) {
            this._eventListeners[eventName] = [];
        }
        else {
            const l = this._eventListeners[eventName].length;
            for (let i = 0; i < l; i++) {
                if (this._eventListeners[eventName][i] === listener) {
                    return;
                }
            }
        }
        this._eventListeners[eventName].push(listener);
    }
    _clearAllRequiredFieldsSetStatuses() {
        Object.keys(this._requiredFieldsSetStatus).forEach((fieldName) => (this._requiredFieldsSetStatus[fieldName] = true));
    }
    _emit(eventName, obj) {
        if (this._eventListeners[eventName]) {
            this._eventListeners[eventName].forEach((listener) => { listener(obj); });
        }
    }
    _hasEventListeners(eventName) {
        return eventName !== undefined ?
            !!this._eventListeners[eventName] :
            Object.keys(this._eventListeners).length > 0;
    }
    _setState(state) {
        if (this._state != state) {
            this._state = state;
            this._emit("state-change", this._state);
        }
    }
    _setIsDirty(value) {
        if (this._isDirty !== value) {
            this._isDirty = value;
            this._emit("is-dirty-change", this._isDirty);
        }
    }
}
exports.SingleEntityBase = SingleEntityBase;
//# sourceMappingURL=SingleEntityBase.js.map